import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./PermissionAdmin.module.css";
import moment from "moment";
import * as publicApi from "../../../service/publicApi";
import PageHeader from "../../pageheader/PageHeader";
import HeadBar from "../headBar/HeadBar";
import Checkbox from "../../material/checkbox/Checkbox";
import Button from "../../material/button/Button";
import { HashLoader } from "react-spinners";
import { convertToYMD } from "../../utility/Helper";

import { CurrentUserContext } from "../../../App";

function PermissionAdmin() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [loading, setLoading] = useState(false);
  const [showCard1, setShowCard1] = useState(false);
  const [personalInformation, setPersonalInformation] = useState(false);

  const [showCard2, setShowCard2] = useState(false);
  const [consentForm, setConsentForm] = useState(false);

  const [showCard3, setShowCard3] = useState(false);
  const [everyTime, setEveryTime] = useState(false);
  const [someTime, setSomeTime] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [date, setDate] = useState("");
  const location = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    setDate(moment().add(543, "years").format("D MMMM YYYY"));
  }, []);
  useEffect(() => {
    if (personalInformation && consentForm) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  }, [everyTime, someTime, personalInformation, consentForm]);

  const backButton = () => {
    nav("/register", {
      state: location.state,
    });
  };
  const submitButton = () => {
    let data = location.state;
    let body = {
      mohpromt_account_id: data.mohpromtId || "",
      ones_did: data.onesDid || "",
      thai_d: data.thaiD || "",
      access_token: data.access_token || "",
      pname: data.pname,
      fname: data.fname,
      lname: data.lname,
      pid: data.pid,
      gender: data.gender,
      birthday_fill: convertToYMD(data.birthday),
      // "birthday_year": data.yearOB,
      // "birthday_month": data.monthOB,
      // "birthday_day": data.dayOB,
      laser: data.laserId,
      current_address: {
        address: data.address,
        village_number: data.moo,
        alley: data.soy,
        road: data.road,
        sub_district_id: data.subDistrictId,
        post_code: data.postCode,
      },
      phone_number: data.phoneNumber,
      email: data.email,
      license_number: data.licenseNumber,
      medical_type: data.medicalType,
      position: data.position,
      staff_role: [],
      username: data.userName,
      password: data.password,
      attachment_file: data.attachFile,
      confirm_password: data.confirmPassword,
      permission: {
        policy_personal_information: personalInformation,
        consent_form: consentForm,
        access_data_every_time: false,
        access_data_some_time: false,
      },
      laboratory: {
        laboratory_name: data.laboratoryName,
        current_address: {
          address: data.labAddress,
          village_number: data.labMoo,
          alley: data.labSoy,
          road: data.labRoad,
          sub_district_id: data.labSubDistrictId,
          post_code: data.labPostCode,
        },
        location: {
          latitude: Number(data.latitude),
          longitude: Number(data.longitude),
        },
      },
    };
    if (data.analystCheck) {
      body["staff_role"].push("ANALYST");
    }
    if (data.approverCheck) {
      body["staff_role"].push("APPROVER");
    }
    register(body);
  };

  const register = async (body) => {
    setLoading(true);
    let res = await publicApi.registerLaboratoryAdmin(body);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "สมัครใช้งานสำเร็จ" });
        nav("/login");
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  return (
    <div className="global-page">
      <HashLoader
        loading={loading}
        style={{ display: "flex", justifyContent: "center" }}
        color="#FF9768"
      />
      <HeadBar menu="register" />
      <PageHeader
        titlename="เงื่อนไขการใช้งานระบบ"
        description="นโยบายการใช้งานสำหรับห้องปฏิบัติการ"
      />

      <div className={styles.content}>
        <div className={styles.card}>
          <div className={styles.mainCard}>
            <Checkbox
              id="checkbox1"
              value={personalInformation}
              setValue={setPersonalInformation}
            />
            <div className={styles.text}>นโยบายคุ้มครองข้อมูลส่วนบุคคล</div>
            <img
              onClick={() => {
                setShowCard1(!showCard1);
              }}
              className={`${showCard1 ? styles.active : ""}`}
              src={require("../../../asset/icon/chevron-down.svg").default}
            ></img>
          </div>
          <div
            className={`${styles.detailCard} ${showCard1 ? styles.detailActive : ""}`}
          >
            <div>
              “ผูกพันธุ์”
              คือระบบดิจิดัลแพลตฟอร์มที่มีจุดประสงค์เพื่อรวบรวมข้อมูลผลการตรวจทางห้องปฏิบัติการที่กรมวิทยาศาสตร์การแพทย์และห้องปฏิบัติการอื่น
              ๆ ให้บริการ และส่งผลกลับไปสู่ประชาชน
              โดยประชาชนสามารถเข้าถึงข้อมูลผลการตรวจของตนเองผ่านทางเว็บไซต์
              หรือแอปพลิเคชัน ผูกพันธุ์
              <div className={styles.return}></div>
              นอกจากนี้
              แพทย์สามารถใช้ผลการตรวจทางห้องปฏิบัติการกรมวิทยาศาสตร์การแพทย์
              นำร่อง 4 การทดสอบ ได้แก่
              <div></div>
              การตรวจ HLA-B*58:01 เพื่อหลีกเลี่ยงอาการผื่น
              แพ้ยาที่เกิดจากการได้รับยา Allopurinol
              <div></div>
              การตรวจ HLA-B*15:02
              เพื่อหลีกเลี่ยงอาการผื่นแพ้ยาที่เกิดจากการได้รับยา Carbamazepine
              <div></div>
              การตรวจ HLA-B*57:01
              เพื่อหลีกเลี่ยงภาวะภูมิคุ้มกันไวเกินจากการใช้ยา Abacavir (Abacavir
              hypersensitivity reaction)
              <div></div>
              การตรวจ NAT2-Diplotype ตรวจยีนย่อยสลายยา Isoniazid
              เพื่อพิจารณาให้ยาในขนาดที่เหมาะสม
              <div className={styles.return}></div>
              โรงพยาบาล /ห้องปฏิบัติการอื่นๆ
              สามารถบันทึกผลการตรวจทางห้องปฏิบัติการเข้าสู่ระบบ
              เพื่อให้ผู้ป่วยเข้าถึงข้อมูลผ่าน ”ผูกพันธุ์” ได้ เนื่องจากการตรวจ
              บางรายการ สามารถตรวจครั้งเดียวและใช้ผลการตรวจได้ตลอดชีวิต
              ดังนั้นจึงทำให้ผู้ป่วยและรัฐประหยัดเงินและเวลาในการตรวจซ้ำเมื่อผู้ป่วยเข้ารับการรักษา
              ต่างโรงพยาบาล
              และแพทย์สามารถพิจารณาใช้ผลการตรวจวางแผนป้องกันและรักษาโรคต่อไป
              ซึ่งบริการดังกล่าวจะมีการควบคุมและรักษาความปลอดภัยด้วย
              มาตรการที่เหมาะสมตามที่กรมวิทยาศาสตร์การแพทย์ได้กำหนดไว้แล้ว
              หรือที่จะกำหนดขึ้นในอนาคต ซึ่งในข้อตกลงการให้บริการนี้ ให้
              <div className={styles.return}></div>
              “ผู้ให้บริการ” หมายความถึง กรมวิทยาศาสตร์การแพทย์
              <div></div>
              “ผู้ใช้บริการ” หมายความถึง ผู้สมัครใช้บริการระบบ
              <div className={styles.return}></div>
              ผู้ให้บริการ และ ผู้ใช้บริการได้ตกลงกันโดยมีข้อความดังต่อไปนี้
              <div className={styles.return}></div>
              1. ผู้ใช้บริการจะต้องสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง ๆ
              ที่ผู้ให้บริการกำหนด โดยการสมัครใช้บริการจะไม่เสียค่าใช้จ่าย
              ทั้งนี้ ผู้ใช้บริการสามารถ
              ใช้บริการได้ภายหลังจากได้มีการรับลงทะเบียนเรียบร้อยแล้ว
              <div></div>
              2.
              ผู้ใช้บริการจะต้องให้ข้อมูลส่วนตัวหรือรายละเอียดที่เกี่ยวข้องกับผู้ใช้บริการตามความเป็นจริง
              เพื่อประโยชน์แก่การใช้บริการ หากผู้ให้บริการตรวจพบว่าข้อมูล
              ส่วนตัวหรือรายละเอียดที่เกี่ยวข้องกับผู้ใช้บริการไม่ชัดเจน
              ไม่ถูกต้อง หรือเป็นข้อมูลเท็จ
              ไม่ว่าผู้ใช้บริการจะให้ข้อมูลนั้นด้วยความสมัครใจหรือความประมาท
              เลินเล่อก็ตาม
              ผู้ให้บริการมีสิทธิที่จะยกเลิกบัญชีของผู้ใช้บริการโดยมิพักต้องบอกกล่าวล่วงหน้า
              <div></div>
              3. ในการใช้บริการบางกรณี
              ผู้ใช้บริการจะต้องทำการยืนยันตัวบุคคลโดยใช้ e-Mail
              หรือหมายเลขบัตรประจำตัวประชาชน 13 หลัก ตามที่ผู้ให้บริการกำหนด
              <div></div>
              4. ห้ามมิให้แอบอ้างหรือกระทำการใด ๆ อันเป็นการละเมิดสิทธิส่วนบุคคล
              โดยการใช้ข้อมูลของผู้อื่นในการสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง
              ๆ ซึ่งผู้ที่กระทำการฝ่าฝืนดังกล่าว ต้องรับโทษตามที่กฎหมายกำหนด
              <div></div>
              5.
              ผู้ใช้บริการจะต้องยินยอมให้ผู้ให้บริการใช้ข้อมูลจากการสมัครใช้บริการหรือลงทะเบียนผ่านช่องทางต่าง
              ๆ เพื่อให้ผู้ใช้บริการสามารถเข้าถึงบริการได้
              <div></div>
              6. ผู้ให้บริการจะเก็บรักษาข้อมูลของผู้ใช้บริการไว้เป็นความลับ
              โดยจะไม่นำข้อมูลดังกล่าวไปเปิดเผย นำไปใช้ประโยชน์ทางการค้า
              หรือกระทำการอื่นใด นอกจาก
              การดำเนินการทางกฎหมายหรือผู้ใช้บริการให้ความยินยอม
              <div></div>
              7.
              ผู้ใช้บริการจะต้องรักษาชื่อบัญชีผู้ใช้งานและรหัสผ่านไว้เป็นความลับ
              หากปรากฏว่ามีผู้อื่นสามารถใช้งานผ่านบัญชีของผู้ใช้บริการได้
              ผู้ให้บริการจะไม่รับผิดชอบ ต่อความเสียหายที่เกิดขึ้น
              <div></div>
              8.
              ผู้ใช้บริการจะต้องปฏิบัติตามเงื่อนไขภายใต้ข้อตกลงการให้บริการโดยเคร่งครัด
              รวมถึงการปฏิบัติตามนโยบาย ประกาศ คำสั่ง ระเบียบ และข้อบังคับของ
              ผู้ให้บริการ
              ตลอดจนกฎหมายที่เกี่ยวข้องกับการใช้บริการทั้งที่ใช้อยู่ในปัจจุบันและที่จะเกิดขึ้นในอนาคต
              อาทิ พระราชบัญญัติว่าด้วยการกระทำความผิดทาง คอมพิวเตอร์ พ.ศ. 2560
              , พระราชบัญญัติว่าด้วยธุรกรรมอิเล็กทรอนิกส์ พ.ศ. 2562 เป็นต้น
              และหรือกฎหมายอื่นที่เกี่ยวข้อง ตลอดจนถือเป็นการกระทำ
              ความผิดทางวินัยด้วยแล้วแต่กรณี
              <div></div>
              9. การแก้ไข เปลี่ยนแปลง
              หรือปรับปรุงเงื่อนไขภายใต้ข้อตกลงการให้บริการนี้
              ผู้ให้บริการจะแจ้งให้ผู้ใช้บริการทราบ ผ่านทางช่องทางต่าง ๆ
              ตามความเหมาะสม กับสถานการณ์
              <div className={styles.return}></div>
              ผู้ใช้บริการได้อ่านและยินยอมให้ผูกพันตามเงื่อนไขภายใต้ข้อตกลงการให้บริการนี้
            </div>
          </div>
        </div>

        <div className={styles.card}>
          <div className={styles.mainCard}>
            <Checkbox
              id="checkbox2"
              value={consentForm}
              setValue={setConsentForm}
            />
            <div className={styles.text}>แบบฟอร์มยินยอมให้เปิดเผยข้อมูล</div>
            <img
              onClick={() => {
                setShowCard2(!showCard2);
              }}
              className={`${showCard2 ? styles.active : ""}`}
              src={require("../../../asset/icon/chevron-down.svg").default}
            ></img>
          </div>
          <div
            className={`${styles.detailCard} ${showCard2 ? styles.detailActive : ""}`}
          >
            <div>
              ข้าพเจ้าให้สัญญา ตกลงจะรักษาความลับข้อมูลด้านสุขภาพของผู้รับบริการ
              อาทิ รายการ และ/หรือรายละเอียด และ/หรือภาพและ/หรือข้อมูลใด ๆ
              ที่เกี่ยวข้อง กับข้อมูลด้านสุขภาพของบุคคล ตาม พรบ. สุขภาพแห่งชาติ
              พ.ศ. 2550 มาตรา 7<div className={styles.return}></div>
              “ข้อมูลด้านสุขภาพของบุคคล เป็นความลับส่วนบุคคล
              นำไปเปิดเผยในประการที่จะทำให้บุคคลนั้นเสียหายไม่ได้
              เว้นแต่การเปิดเผยนั้นเป็นไปตามความประสงค์ ของบุคคลนั้นโดยตรง
              หรือมีกฎหมายเฉพาะบัญญัติให้ต้องเปิดเผย แต่ไม่ว่าในกรณีใด ๆ
              ผู้ใดจะอาศัยอำนาจหรือสิทธิ ตามกฎหมายว่าด้วยข้อมูลข่าวสารของ ราชการ
              หรือกฎหมายอื่นเพื่อขอเอกสารเกี่ยวกับข้อมูลด้านสุขภาพของบุคคลที่ไม่ใช่ของตนไม่ได้”
              และประมวลกฎหมายอาญา มาตรา 323 บัญญัติไว้ว่า
              <div className={styles.return}></div>
              “ผู้ใดล่วงรู้หรือได้มาซึ่งความลับของผู้อื่นโดยเหตุที่เป็นเจ้าพนักงานผู้มีหน้าที่
              โดยเหตุที่ประกอบอาชีพแพทย์ เภสัชกร คนจำหน่ายยา นางผดุงครรภ์
              ผู้พยาบาล นักบวช หมอความ
              ทนายความหรือผู้สอบบัญชีหรือโดยเหตุที่เป็นผู้ช่วยในการประกอบอาชีพนั้น
              แล้วเปิดเผยความลับนั้นในประการที่น่าจะเกิดความ
              เสียหายแก่ผู้หนึ่งผู้ใด ต้องระวางโทษจำคุกไม่เกินหกเดือน
              หรือปรับไม่เกินหนึ่งพันบาท หรือทั้งจำทั้งปรับ”
              <div className={styles.return}></div>
              ข้าพเจ้าตกลงรักษาข้อมูลที่เป็นความลับและไม่เปิดเผยข้อมูลของผู้ป่วย
            </div>
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <Button
            style={{ width: 120, background: "#FFFFFF" }}
            onClick={backButton}
          >
            ย้อนกลับ
          </Button>
          <Button
            disabled={disabledButton || loading}
            style={{ width: 120 }}
            onClick={submitButton}
          >
            ยอมรับ
          </Button>
        </div>
      </div>
    </div>
  );
}

export default PermissionAdmin;
